import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PersonClient, RepresentationType } from '@models/clients';
import { MatterClientType } from '@models/matter';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CreatePersonFormBase } from '../../create-person-form-base.component';
import { TestHooks } from './create-person-client-side-form.hooks';

@UntilDestroy()
@Component({
	selector: 'app-aps-create-person-client-side-form',
	templateUrl: './create-person-client-side-form.component.html',
	standalone: false,
})
export class CreatePersonClientSideFormComponent extends CreatePersonFormBase {
	testHooks = TestHooks;
	@Input() firstName: string;
	@Input() middleName: string;
	@Input() lastName: string;
	@Input() phone: string;
	@Input() workPhone: string;
	@Input() clientName: string;
	@Input() selectedRepresentation = RepresentationType.NONE;
	@Input() showPrimaryClientOption = false;
	@Input() showIDsOption = false;
	@Input() showRepresentationOption = true;
	@Input() matterClientType: MatterClientType;
	@Input() dateOfBirth;
	@Input() minify;
	@Input() primary;
	@Input() set gender(gender: string) {
		this.selectedGender = gender;
	}

	@Input() set title(title: string) {
		this._title = title;
	}

	@Input() set email(email: string) {
		this._email = email;
	}
	@Output() onCancel = new EventEmitter<string>();
	@Output() onCreate = new EventEmitter<PersonClient>();

	onSubmitAction(): void {
		this.onCreate.emit({
			...this.getBaseClientData(),
			primary: this.primary,
			dateOfBirth: this.dateOfBirth ?? '',
		} as PersonClient);
	}

	cancel() {
		this.onCancel.emit();
	}
}
